import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../config/authaxios";

const initialState = { status: null, data: [], loading: false, message: '' };

export const deleteCategoryAction = createAsyncThunk(
  "dalete-category",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.delete(`/admin/product/category`, { data });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const deleteCategorySlice = createSlice({
  name: "dalete-category",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(deleteCategoryAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteCategoryAction.fulfilled, (state, action) => {
      state.loading = false;
      state.message = action.payload?.message;
      state.status = action.payload.status_code;
      if(state.status==401){
        localStorage.clear()
      }
      state.data = action.payload?.response;
    });
    builder.addCase(deleteCategoryAction.rejected, (state, action) => {
      state.loading = false;
      state.message = action.payload?.message;
      state.status = action.payload.status_code;
      state.error = action.error.message;
    });
  },
});

export const deleteCategoryReducer = deleteCategorySlice.reducer;
